import React from 'react';
import { Form, Input, InputProps } from 'antd';
import { FormItemProps, Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';
import styled from 'styled-components';

import { FormFieldLabel } from './FormFieldLabel';

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 5px;

  .ant-form-item-label {
    padding-bottom: 0px;
  }
`;

export type FormInputProps = {
  name: string | string[];
  label?: string;
  allowClear?: boolean;
  required?: boolean;
  rules?: Rule[];
  disabled?: boolean;
  onBlur?: () => void;
  normalize?: FormItemProps['normalize'];
  type?: InputProps['type'];
  dependencies?: NamePath[];
  maxLength?: InputProps['maxLength'];
};

export const FormInput: React.FC<FormInputProps> = ({
  name,
  label,
  required,
  rules,
  disabled,
  onBlur,
  normalize,
  type,
  dependencies,
  maxLength,
}) => {
  return (
    <StyledFormItem
      name={name}
      style={{ marginBottom: '5px' }}
      label={<FormFieldLabel required={required}>{label}</FormFieldLabel>}
      rules={rules}
      normalize={normalize}
      dependencies={dependencies}
    >
      <Input disabled={disabled} onBlur={onBlur} type={type} maxLength={maxLength} />
    </StyledFormItem>
  );
};
